import { Model } from '@vuex-orm/core'

export class UnitsFrom extends Model {
  static entity = 'unitsFrom'
  static primaryKey = ['unit_id', 'substitution_id']

  static fields () {
    return {
      unit_id: this.attr(null),
      substitution_id: this.attr(null)
    }
  }
}

export default UnitsFrom
